var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Cards',{staticClass:"cards--grid-nav",attrs:{"per-row":"4","md-per-row":"2","sm-per-row":"2","xs-per-row":"1"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }